import React from 'react';

import { ModalBody } from 'components/_core/Modal';
import Message from 'components/_core/Message';
import Button from 'components/_core/Button';

const InvalidPlan = ({ setJoinModalScreen }) => (
    <ModalBody>
        <Message heading="Plan not available" error small>
            The plan you selected isn't available. Please choose a plan to continue.
        </Message>
        <Button fluid orange bold onClick={() => setJoinModalScreen('plans')}>View Plans</Button>
    </ModalBody>
);

InvalidPlan.displayName = 'InvalidPlan';

export default InvalidPlan;
